import { Component } from '@angular/core';

import { HisAuthService } from 'hisng';

@Component( {
    selector: 'res-patent-documentation-link',
    templateUrl: './documentation-link.component.html'
} )
export class PatentDocumentationLinkComponent {
    public target: string;
    public title: string;

    constructor( public auth: HisAuthService ) {
        this.target = 'site=Patente-HISinOne.xhtml';
        this.title = 'fs.res.documentation.patent';
    }
}
